import { Type } from 'class-transformer';
import { AbstractData } from '@/modules/backend/Dto/AbstractData';
import { Company } from '@/modules/backend/Entities/Company';
import { Building } from '@/modules/backend/Entities/Building';
import { Location } from '@/modules/backend/Entities/Location';
import { Account } from '@/modules/backend/Entities/Account';
import { Counter } from '@/modules/backend/Entities/Counter';
import { SearchEntityType } from '@/modules/backend/Dto/SearchRequestData';

export interface SearchResponseDataInterface {
  query: string;
  types: SearchEntityType[];

  companies: Company[];
  buildings: Building[];
  locations: Location[];
  accounts: Account[];
  counters: Counter[];
}

export class SearchResponseData extends AbstractData implements SearchResponseDataInterface {
  public readonly query!: string;
  public readonly types!: SearchEntityType[];

  @Type(() => Company)
  public readonly companies!: Company[];

  @Type(() => Building)
  public readonly buildings!: Building[];

  @Type(() => Location)
  public readonly locations!: Location[];

  @Type(() => Account)
  public readonly accounts!: Account[];

  @Type(() => Counter)
  public readonly counters!: Counter[];
}
